/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

export const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: "IBM Plex Mono", monospace;
`;

export const H2 = styled.h2`
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.text.default};
  font-family: "IBM Plex Mono", monospace;
  font-weight: 500;
`;

export const H3 = styled.h3`
  font-family: "IBM Plex Mono", monospace;
  font-size: "24px";
  font-weight: 600;
  color: ${({ theme }) => theme.text.default};
`;
